import { Component, Injector, OnInit } from '@angular/core';
import { FacilityService } from 'src/app/core/services/facility.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { ExportService } from '../../services/export.service';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { ExportDeclarationGetsPortalRequest } from 'src/app/core/models/transport-operation/gets-exportDeclaration-request';
import { ExportDeclarationGetsPortalResponse, GetsErrorDetail } from 'src/app/core/models/transport-operation/gets-exportDeclaration-response';

@Component({
  selector: 'laas-export-header-detail',
  templateUrl: './export-header-detail.component.html',
  styleUrls: ['./export-header-detail.component.scss']
})
export class ExportHeaderDetailComponent extends SessionBaseComponent implements OnInit {

  exportHeader: any;

  //options
  orgIdOptions: any[];
  forwarderOptions: any[];
  billObjectOptions: any[];
  billObjectTypeOptions: any[];
  shipMethodOptions: any[];
  docTypeOptions: any[];
  docType1Options: any[];
  currenyOptions: any[];
  exportCodeOptions: any[];
  toCountryOptions: any[];
  toCityOptions: any[];
  detailObjs: any[];

  isShowEditBtn: boolean;
  isShowCancelBtn: boolean;
  isHkFacility: boolean;
  canGetsBtn: boolean;
  showGetsErrorDialog: boolean;
  getsErrorDetails: GetsErrorDetail[];
  getsErrorSummary: string;

  constructor(
    injector: Injector,
    private exportService: ExportService,
    private facilityService: FacilityService,
    private commonDataService: CommonDataService,
    private dropdownOptionService: DropdownOptionsService,
  ) {
    super(injector);
    //options
    this.orgIdOptions = [];
    this.forwarderOptions = [];
    this.billObjectOptions = [];
    this.billObjectTypeOptions = [];
    this.shipMethodOptions = [];
    this.orgIdOptions = [];
    this.docTypeOptions = [];
    this.docType1Options = [];
    this.currenyOptions = [];
    this.exportCodeOptions = [];
    this.toCountryOptions = [];
    this.toCityOptions = [];
    this.detailObjs = [];
    this.isShowEditBtn = false;
    this.isShowCancelBtn = false;
    this.isHkFacility = false;
    this.canGetsBtn = false;
    this.showGetsErrorDialog = false;
    this.getsErrorDetails = [];
    this.getsErrorSummary = '';
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();
    const exportDeclarationNo = this.routeStateService.getCurrent().data.exportDeclarationNo;

    try{
       this.exportHeader = await this.exportService.getExportHeader(exportDeclarationNo);
       this.detailObjs = this.exportHeader.doDetailList;
    }catch(err: any) {
      console.log('get export header occur error: ' + JSON.stringify(err));
    }

    this.commonDataService.getAppCsmSetting('HKFacilitySetting').subscribe({
      next:(option:any)=>{
        this.isHkFacility = option.appCsmSettingDetailList.some((item: { setupValue: string }) =>
          item.setupValue === this.exportHeader.facility
        );
        console.log("this.isHkFacility" + this.isHkFacility+"this.appCsmSettingDetailList"+option.appCsmSettingDetailList);
        this.canGetsBtn = this.isHkFacility && (this.exportHeader.status == '0' || this.exportHeader.status == 'GE');
      }
    });



    //options
    this.facilityService.getLetterOrgOptions(this.exportHeader.facility, "").subscribe({
      next: result => {
        this.orgIdOptions = [...result].map((x: any) => {
          return {
            label: `${x.legalEntityOUCode}-${x.legalEntityOUName}`,
            value: x.legalEntityOUCode,
          };
        });
      }
    });

    this.facilityService.getForwarderOptions(this.exportHeader.facility).subscribe({
      next: result => {
        this.forwarderOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      },
      complete: () => {

      }
    });

    this.facilityService.getBillObjectOptions(this.exportHeader.facility, this.exportHeader.billObjectType).subscribe({
      next: result => {
        this.billObjectOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getBillObjectTypeOptions().subscribe({
      next: result => {
        this.billObjectTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getShipMethodOptions().subscribe({
      next: result => {
        this.shipMethodOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getDocTypeOptions().subscribe({
      next: result => {
        this.docTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getDocType1Options().subscribe({
      next: result => {
        this.docType1Options = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getCurrencyOptions().subscribe({
      next: result => {
        this.currenyOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.facilityService.getExportCodeOptions(this.exportHeader.facility).subscribe({
      next: result => {
        this.exportCodeOptions= [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.commonDataService.getAppCsmSetting('AllowEditExportDeclarationStatus').subscribe({
      next: ({ appCsmSettingDetailList }: { appCsmSettingDetailList: { facility: string,setupValue: string }[] }) => {
        const facilityAllowStatusList = appCsmSettingDetailList.filter((x) => x.facility === this.exportHeader.facility);
        const allAllowStatusList = appCsmSettingDetailList.filter((x) => x.facility === 'ALL');
        const allowStatusList = (facilityAllowStatusList.length ? facilityAllowStatusList : allAllowStatusList).map((x) => x.setupValue);
        this.isShowEditBtn = allowStatusList.includes(this.exportHeader.status);
        this.isShowCancelBtn = allowStatusList.includes(this.exportHeader.status);
      }
    });


    this.dropdownOptionService.getToCountryOptions().subscribe({
      next: (options: any[]) => {
        this.toCountryOptions = options.map((x) => ({
          label: x.optionDesc,
          value: x.optionCode,
        }));
      },
    });

    this.dropdownOptionService.getAllCityOptions().subscribe({
      next: (options: any[]) => {
        this.toCityOptions = options.map((x) => ({
          label: x.name,
          value: x.seqNo.toString(),
        }));
      },
    });

    console.log(this.exportHeader);
  }

  gotoEdit(event: any): void{
    this.routeStateService.navigateTo('/TransportOperation/ExportHeaderEdit', this.exportHeader);
  }

  gotoList(event: any): void{
    this.routeStateService.navigateTo('/TransportOperation/ExportSearch', this.exportHeader);
  }

  callGets(event: any): void{
    this.loader.show();
    const callGetsRequest: ExportDeclarationGetsPortalRequest = {
      exportDeclarationNo: this.exportHeader.exportDeclarationNo,
      userName: this.userProfile.userName
    };
    this.exportService.callGets(callGetsRequest).subscribe({
      next: (result: ExportDeclarationGetsPortalResponse) => {
        console.log(result);
        this.loader.hide();
        if (result?.successFlag === 'Y') {
          this.canGetsBtn = false;
          this.toastService.success(this.translateService.instant('ExportDeclarationDetails.Message.GetsSuccess'));
          window.location.reload();
          return;
        }

        if (result?.errorDetails && result.errorDetails.length > 0) {
          this.getsErrorSummary = result.errorMessage ?? '';
          this.getsErrorDetails = result.errorDetails;
          this.showGetsErrorDialog = true;
          return;
        }

        if (result?.errorMessage != null) {
          this.toastService.error(result.errorMessage);
        } else {
          this.toastService.error('GETS 呼叫失敗');
        }
      },
      error: (e) => {
        this.loader.hide();
        this.commonDataService.getErrorCodes(this.laasSetting.language, e.error.category).subscribe({
          next: (errorList) => {
            console.log(errorList);
            const matchedError = errorList.find((error: any) => error.errorCode == e.error.errorCode);
            this.toastService.error(matchedError?.errorMsg ?? 'GETS 呼叫失敗');
          }
        });
      }
    });
  }
}
